export default __webpack_public_path__ + "static/media/includeImg1.02b68eb6.jpg";